import { ca } from '@cian/analytics';

export function trackFirstMessageSend(showPushNotification: boolean, isPushCheck: boolean) {
  if (showPushNotification) {
    const pushOnOff = isPushCheck ? 'PushOn' : 'PushOff';

    ca('event', {
      action: 'Send',
      category: 'subscription',
      label: `From_Chats/${pushOnOff}`,
    });
  }
}
